import { computed } from 'vue'
import Cookies from 'js-cookie'

export function useConstructionLogo() {
  const assetsOverride = computed(() => Cookies.get('assets-override'))
  const isLocal = computed(() => location.hostname === 'localhost')

  const onClearAssetsOverride = () => {
    Cookies.remove('assets-override', { path: '/' })
    const url = new URL(location.href)
    if (url.searchParams.has('assets-override')) {
      url.searchParams.delete('assets-override')
    }
    location.href = url.toString()
  }

  return {
    assetsOverride,
    isLocal,
    onClearAssetsOverride,
  }
}
